export default __webpack_public_path__ + "static/media/Crio_demo.be8b9a72.mp4";